import { AlertCircle } from 'lucide-react'
import styles from '../../styles/emailTemplateCard.module.css'
import { cn } from '@/lib/utils/helpers'

/** Field error — same pattern as PMC/company (`AlertCircle` + `#b8313b` text). */
export function EmailTemplateFieldError({
  show,
  message,
  className,
  testId,
}: {
  show: boolean
  message?: string
  className?: string
  testId?: string
}) {
  if (!show || !message) return null

  return (
    <div className={cn(styles.errorMessage, className)} role="alert" data-testid={testId}>
      <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  )
}
